<template>
  <EquipmentList :list="details" />
</template>

<script>
import { mapGetters } from 'vuex';
import { mapEquipmentFields } from '@/utils';
import { EquipmentList } from './components';

export default {
  name: 'EquipmentDetailsContainer',
  components: {
    EquipmentList,
  },
  props: {
    equipmentData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters({
      inspectionConfig: 'config/inspectionConfig',
    }),
    details() {
      const { equipmentInfoFields, corrosionLayers, platformFeatures } = this.inspectionConfig;
      return mapEquipmentFields({
        equipmentInfoFields,
        corrosionLayers,
        platformFeatures,
        equipmentData: this.equipmentData,
      });
    },
  },
};
</script>
